import { useEffect, useRef } from "react";
import { useAnalytics } from "hooks/useAnalytics";
import { ANALYTICS_EVENTS } from "analytics";

/**
 * Sets PostHog workspace group and optionally project context + project_opened event.
 * Call when the user is in a workspace or project context (e.g. in ProjectLayoutWrapper).
 */
export const useWorkspaceProjectAnalytics = (
  workspaceId: string | undefined,
  projectId: string | undefined,
  projectName?: string
) => {
  const { setWorkspaceGroup, setProjectContext, trackEvent } = useAnalytics();
  const trackedProjectRef = useRef<string | null>(null);

  useEffect(() => {
    if (!workspaceId) return;
    setWorkspaceGroup(workspaceId);
  }, [workspaceId, setWorkspaceGroup]);

  useEffect(() => {
    if (!projectId || !workspaceId) return;
    setProjectContext(projectId, workspaceId, projectName);

    if (trackedProjectRef.current === projectId) return;
    trackedProjectRef.current = projectId;
    trackEvent(ANALYTICS_EVENTS.PROJECT_OPENED, {
      project_id: projectId,
      workspace_id: workspaceId,
      ...(projectName && { project_name: projectName }),
      from: "navigation",
    });
  }, [projectId, workspaceId, projectName, setProjectContext, trackEvent]);
};
